import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Box, 
  Text, 
  IconButton, 
  ActionMenu,
  ActionList,
} from '@primer/react';
import { 
  KebabHorizontalIcon,
  PersonIcon,
  ChevronRightIcon,
  TrashIcon,
  BookIcon,
  TasklistIcon
} from '@primer/octicons-react';
import { useCommonContext } from '../../contexts/common';
import UserAvatar from '../user-avatar';

interface HocSinh {
  id: number;
  ho_ten: string;
  ma_hs: string;
  trang_thai: string;
  dm_gioitinh_id: number;
  gioi_tinh: string;
  ten_he: string;
  ten_lop: string;
}

interface PhuHuynhChildItemProps {
  hocSinh: HocSinh;
  isSelected: boolean;
  onSelected: () => void;
  onDeleted: () => void;
}

const PhuHuynhChildItem: React.FC<PhuHuynhChildItemProps> = ({
  hocSinh,
  isSelected,
  onSelected,
  onDeleted
}) => {
  const { translate } = useCommonContext();

  const subText = [hocSinh.ma_hs, hocSinh.ten_lop].filter(Boolean).join(" · ");

  return (
    <Box
      title={[hocSinh.ma_hs, hocSinh.ten_he, hocSinh.ten_lop].filter(Boolean).join(" - ")}
      sx={{ display: "flex", alignItems: "center", gap: 2, px: 2, py: 2, borderRadius: 2 }}
    >
      <UserAvatar fullName={hocSinh.ho_ten} size="large" />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Text as="div" sx={{ fontWeight: 600, fontSize: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {hocSinh.ho_ten}
        </Text>
        {subText && (
          <Text as="div" sx={{ fontSize: 0, color: "fg.muted", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {subText}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default PhuHuynhChildItem;